import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution } from './Institution';

export interface InstitutionGroupRow {
  id: number;
  institution_id: number;
  title: string;
  status: string;
  description: string;
  created_at: string;
  color_code: string;
}

export const InstitutionGroup: Entity<InstitutionGroupRow> = {
  id: 'InstitutionGroup',
  title: 'Group',
  service: 'main',
  rowLabel: (row: InstitutionGroupRow) => row.title,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_group',
  },
  security: [
    { role: 'staff', action: 'all', access: 'conditional', condition: "status = 'ACTIVE'" },
    {
      role: 'all-authed',
      action: 'read',
      access: 'conditional',
      condition: "status = 'ACTIVE' AND institution_id IN ({accessInstitutionIds})",
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: "status = 'ACTIVE' AND institution_id = {adminInstitutionId}",
    },
  ],
  defaultSort: [['title', 'ASC']],
  defaultFilters: [
    { fieldId: 'institution_id', operator: 'eq', value: '' },
    { fieldId: 'title', operator: 'ct', value: '' },
  ],
  refOrderClause: 'SELECT ZZ.title FROM institution_group ZZ WHERE ZZ.id',
  listRowLink: '/admin/institution-group/display/{key}',
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
      autoIncrement: true,
    },
    title: {
      seq: 10,
      type: FieldType.Text,
      label: 'Title',
      mandatory: true,
      listColumn: true,
      maxLength: 80,
    },
    status: {
      seq: 12,
      label: 'Status',
      type: FieldType.Options,
      mandatory: true,
      persistence: PersistenceType.BackEndOnly,
      options: [
        { id: 'ACTIVE', label: 'active' },
        { id: 'INACTIVE', label: 'inactive' },
      ],
    },
    description: {
      seq: 15,
      label: 'Description',
      type: FieldType.Text,
      persistence: PersistenceType.BackEndOnly,
    },
    institution_id: {
      seq: 20,
      label: 'Institution',
      type: FieldType.Reference,
      refEntity: Institution,
      persistence: PersistenceType.SetOnCreateOnly,
      mandatory: true,
    },
    created_at: {
      seq: 25,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    color_code: {
      seq: 30,
      label: 'Colour Code',
      type: FieldType.Colour,
    },
  },
};
